<template>
  <v-card max-width="1400px">
    <span class="red--text">{{ errorMessage }}</span>
    <v-card-title>DISTRIBUCIONES</v-card-title>

    <v-card-text>

      <periodo-distribucion-autocomplete @periodoDistribucion="setPeriodoDistribucion"
        :periodoDistribucion="periodoDistribucion" clearable />
      <tipo-generacion-autocomplete @tipoGeneracion="setTipoGeneracion" clearable />
      <v-data-table :loading="loading" item-class="class" :headers="headers" dense :items="generacionesFiltrado"
        disable-sort>
        <template v-slot:item.fechaInicio="{ item }">
          {{ item.fechaInicio | dateFormat }}
        </template>
        <template v-slot:item.fechaFin="{ item }">
          {{ item.fechaFin | dateFormat }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-menu offset-y :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn small v-bind="attrs" v-on="on">
                <v-icon>arrow_drop_down</v-icon>
              </v-btn>
            </template>
            <v-list expand>
              <!-- <v-list-item>
                <DistribucionDetalle block :generacionId="item.id" />
              </v-list-item> -->
              <!-- <v-list-item>
                <v-btn block small>ASIGNACIONES</v-btn>
              </v-list-item> -->
              <v-list-item v-if="item.estado == 'Pendiente'">
                <v-btn block small :loading="liquidando" @click="liquidar(item)">LIQUIDAR</v-btn>
              </v-list-item>
              <v-list-item v-if="item.estado == 'Liquidado'">
                <v-btn block color="warning" small @click="cerrar(item)">Cerrar</v-btn>
              </v-list-item>

              <v-list-item>
                <v-btn :loading="loading" block color="warning" small @click.once="descargarTotales(item)">Descargar
                  Totales</v-btn>
              </v-list-item>

              <v-list-item>
                <v-btn :loading="loading" block color="warning" small
                  @click.once="descargarTotalesPendientes(item)">Descargar
                  Totales Pendientes</v-btn>
              </v-list-item>

              <v-list-item>
                <v-btn :loading="loading" block color="warning" small
                  @click.once="descargarTotalesPagados(item)">Descargar Totales
                  Pagado</v-btn>
              </v-list-item>



              <v-list-item>
                <v-btn :loading="loading" block color="" small @click.once="descargarOnis(item)">Descargar
                  ONIS</v-btn>
              </v-list-item>

              <v-list-item>
                <ModificarGeneracion :generacion="item" @saved="refresh()" />
              </v-list-item>

            </v-list>
          </v-menu>

        </template>
      </v-data-table>




    </v-card-text>

    <v-card-actions>
      <v-btn @click="$router.push({ path: '/' })">VOLVER</v-btn>
      <!-- <AgregarGeneracion @agregado="agregado" /> -->
      <modificar-generacion modo="insert" @saved="refresh()" />
      <v-btn :disabled="!periodoDistribucion" @click="imprimirComparativo"><v-icon right>print</v-icon>COMPARATIVO
        BOLSAS</v-btn>
      <v-btn :disabled="!periodoDistribucion" @click="imprimirLista"><v-icon right>print</v-icon>LISTA DE DISTRIBUCIONES</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import axios from "axios";
// import AgregarGeneracion from "@/components/distribucion/AgregarGeneracion.vue";
import PeriodoDistribucionAutocomplete from "@/components/shared/PeriodoDistribucionAutocomplete.vue";
import ModificarGeneracion from "@/components/distribucion/ModificarGeneracion.vue";
// import DistribucionDetalle from "@/components/distribucion/DistribucionDetalle.vue";
import TipoGeneracionAutocomplete from '@/components/shared/TipoGeneracionAutocomplete.vue'
import { saveAs } from "file-saver";
import moment from 'moment';


export default {
  data() {
    return {
      generaciones: [],
      generacionesFiltrado: [],
      tipoLiquidacion: null,
      liquidando: false,
      periodoDistribucion: null,
      errorMessage: "",
      loading: false,
      headers: [
        { text: 'Periodo', value: 'periodoDistribucion.descripcion' },
        { text: 'Inicio', value: 'fechaInicio' },
        { text: 'Fin', value: 'fechaFin' },
        { text: 'id', value: 'id' },
        { text: 'Tipo', value: 'tipoGeneracion.descripcion' },
        { text: 'Nombre corto', value: 'nombreCorto' },
        {
          text: 'Descripcion',
          align: 'start',
          sortable: false,
          value: 'descripcion',
        },
        { text: 'Accion', value: 'actions' },
      ]
    };
  },
  mounted() {

    this.refresh();

  },
  methods: {

    imprimirComparativo() {
      this.loading = true;
      axios.post("/reports", {
        dbName: "SIAPA",
        reportName: "comparativo_bolsa_distribucion.jrxml",
        base64: true,
        params: [
          { nombre: "ID_PERIODO", valor: this.periodoDistribucion.id, tipo: "integer" },
          { nombre: "USUARIO", valor: this.$store.getters.user.username }
        ],
      })
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.errorMessage = err.response.data;
        });
    },

    imprimirLista() {
      this.loading = true;
      axios.post("/reports", {
        dbName: "SIAPA",
        reportName: "reporte_generaciones_periodo.jrxml",
        base64: true,
        params: [
          { nombre: "ID_PERIODO", valor: this.periodoDistribucion.id, tipo: "integer" },
          { nombre: "USUARIO", valor: this.$store.getters.user.username }
        ],
      })
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.errorMessage = err.response.data;
        });
    },

    doFilter() {


      if (this.tipoGeneracion == null && this.periodoDistribucion == null) {
        this.generacionesFiltrado = this.generaciones;
        return;
      }

      this.generacionesFiltrado = this.generaciones.filter((g) => {
        console.log(g)
        const coincideTipo = this.tipoGeneracion == null || (this.tipoGeneracion != null && g.tipoGeneracion?.id === this.tipoGeneracion.id);
        const coincidePeriodo = this.periodoDistribucion == null || (this.periodoDistribucion != null && g.periodoDistribucion?.id === this.periodoDistribucion.id);
        return coincideTipo && coincidePeriodo;
      });


    },
    async refresh() {

      this.loading = true;
      await axios.get("/generaciones")
        .then((response) => {
          this.generaciones = response.data.map((g) => {
            // return {groupBy: g.fechaInicio + ' - ' + g.fechaFin, ...g };
            return { ...g, class: 'green lighten-5' };
          });

          //Ordenamos
          this.generaciones.sort((a, b) =>
            // (b.fechaInicio || '').localeCompare(a.fechaInicio || '') ||
            // (b.fechaFin || '').localeCompare(a.fechaFin || '')
            b.id - a.id
          );

          this.generacionesFiltrado = this.generaciones;

          this.setTipoGeneracion(this.tipoGeneracion);

        })
        .catch((err) => {
          console.log(err);
        });

      this.loading = false;

    },
   
    cerrar(generacion) {
      if (!confirm("desera cerrar esta generacion?")) return;
      axios
        .post(`/generaciones/${generacion.id}/cerrar`)
        .then((response) => {
          console.log(response);
          this.generaciones.forEach((gen) => {
            if (gen.id == generacion.id) {
              gen.estado = response.data.estado;
              return;
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    anular(generacion) {
      axios
        .post(`/generaciones/${generacion.id}/anular`)
        .then((response) => {
          console.log(response);
          this.generaciones.forEach((gen) => {
            if (gen.id == generacion.id) {
              gen.estado = response.data.estado;
              return;
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    agregado(generacion) {
      this.generaciones.push(generacion);
    },
    liquidar(generacion) {
      this.errorMessage = "";
      this.liquidando = true;
      axios
        .post(`/generaciones/${generacion.id}/liquidar`)
        .then((response) => {
          this.liquidando = false;
          console.log(response);
          this.generaciones.forEach((gen) => {
            if (gen.id == generacion.id) {
              gen.estado = response.data.estado;
              return;
            }
          });
        })
        .catch((err) => {
          this.liquidando = false;
          this.errorMessage = err.response.data;
          console.log(err);
        });
    },
    descargarTotales(generacion) {
      this.loading = true;
      axios.post("/reports", {
        dbName: "SIAPA",
        reportName: "escenarioTotales.jrxml",
        base64: true,
        params: [
          { nombre: "generacion_id", valor: generacion.id, tipo: "integer" },
          { nombre: "usuario", valor: this.$store.getters.user.username }
        ],
      })
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.errorMessage = err.response.data;
        });
    },
    
    descargarTotalesPendientes(generacion) {
      this.loading = true;
      axios
        .get("/report/generacion/totalesPendientes/" + generacion.id)
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
          this.loading = false;
          // this.$store.dispatch("showSnack", "Descargando..!");
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.errorMessage = "Error en la consulta";
          // this.$store.dispatch("showSnack", "Error");
        });
    },
    // descargarTotales(generacion) {
    //   this.loading = true;
    //   axios
    //     .get("/report/generacion/totales/" + generacion.id)
    //     .then((response) => {
    //       this.loading = false;

    //       var blob = this.b64toBlob(
    //         response.data.fileContent,
    //         "application/pdf",
    //         null
    //       );
    //       saveAs(blob, response.data.fileName);

    //       // this.$store.dispatch("showSnack", "Descargando..!");
    //     })
    //     .catch((err) => {
    //       this.loading = false;
    //       console.log(err);
    //       this.errorMessage = "Error en la consulta";
    //       // this.$store.dispatch("showSnack", "Error");
    //     });
    // },

    descargarOnis(generacion) {
      this.loading = true;
      axios
        .get("/report/generacion/onis/" + generacion.id)
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          this.loading = false;
          saveAs(blob, response.data.fileName);
          // this.$store.dispatch("showSnack", "Descargando..!");
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.errorMessage = "Error en la consulta";
          // this.$store.dispatch("showSnack", "Error");
        });
    },
    setTipoGeneracion(e) {

      this.tipoGeneracion = e;
      this.doFilter();

    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    setPeriodoDistribucion(e) {

      this.periodoDistribucion = e;
      this.doFilter();

    },

  },
  filters: {
    dateFormat(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
  },
  components: {
    // AgregarGeneracion,
    ModificarGeneracion,
    // DistribucionDetalle,
    TipoGeneracionAutocomplete,
    PeriodoDistribucionAutocomplete,
  },
};
</script>